import { axiosClient } from "../../api/api";

type formState = {
  name: string;
  email: string;
  question: string;
  /** ALTCHA proof-of-work payload. Required by the requireCaptcha middleware. */
  altcha: string;
  /** Honeypot. Must stay empty; a value gets the request rejected. */
  contactReason: string;
};

export const Contact = (FormState: formState) => {
  const { name, email, question, altcha, contactReason } = FormState;
  return axiosClient
    .post("/api/survey/contact", {
      name,
      email,
      question,
      altcha,
      contactReason,
    })
    .then((response) => response.data);
};
